export class CustomIntervalEntity {

    public static fromDto(dto: any): CustomIntervalEntity {
        if (!dto) {
            return new CustomIntervalEntity();
        }
        const entity = new CustomIntervalEntity();

        entity.id = dto.id;
        entity.scheduleId = dto.scheduleId;
        entity.afterInterval = dto.afterInterval;
        entity.duration = dto.duration;
        entity.text = dto.text;
        entity.concurrency = dto.concurrency;
        return entity;
    }

    public static fromDtoArray(dtoArray: any[]): CustomIntervalEntity[] {
        const entities: CustomIntervalEntity[] = [];
        if (!dtoArray) {
            return entities;
        }
        for (const dto of dtoArray) {
            const entity = CustomIntervalEntity.fromDto(dto);
            entities.push(entity);
        }
        return entities;
    }

    public static toDtoArray(entityArray: CustomIntervalEntity[]): any[] {
        const dtos = [];
        for (const entity of entityArray) {
            dtos.push(entity.toDto());
        }
        return dtos;
    }

    public id: string = null;
    public scheduleId: string = null;
    public afterInterval: number = 0;
    public duration: number = 15;
    public text: string = 'Paus';
    public concurrency: string;
    public toDto(): any {
        return {
            afterInterval: this.afterInterval,
            duration: this.duration,
            text: this.text,
            concurrency: this.concurrency
        };
    }
}
